<template>
  <el-table-column
    prop="status"
    label="Státusz"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      <el-tag v-if="scope.row.is_active" size="small" type="success">Aktív</el-tag>
      <el-tag v-if="!scope.row.is_active" size="small" type="danger">Inaktív</el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'name',
  };
</script>
